import { jsPDF } from "jspdf";
import "jspdf-autotable";
import Headerimg from "../../../utils/header.jpeg";
import Footerimg from "../../../utils/footer.jpeg";

/* === Helpers === */
function formatText(txt) {
  if (!txt) return "";
  const base = txt.toString().toLowerCase();
  return base.replace(/[\p{L}\p{M}]+/gu, (word) =>
    word.charAt(0).toUpperCase() + word.slice(1)
  );
}

function applyHeaderFooter(doc, title, paciente) {
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  for (let page = 1; page <= doc.getNumberOfPages(); page++) {
    doc.setPage(page);
    // Header
    doc.addImage(Headerimg, "JPEG", 0, 0, 210, 40);
    doc.setFontSize(16);
    doc.setTextColor(0, 0, 0); // título en negro
    doc.text(formatText(title), pageWidth / 2, 45, { align: "center" });
    doc.setFontSize(12);
    doc.text(`${formatText(paciente)}`, pageWidth / 2, 52, { align: "center" });
    // Footer
    doc.addImage(Footerimg, "JPEG", 0, pageHeight - 40, 210, 40);
  }
}

function checkNewPage(doc, startY) {
  const pageHeight = doc.internal.pageSize.getHeight();
  if (startY > pageHeight - 80) {
    doc.addPage();
    return 60; // reiniciar altura
  }
  return startY;
}

/* === Evoluciones === */
export function exportarEvolucionesPDF(evoluciones, paciente) {
  const doc = new jsPDF("p", "mm", "a4");

  evoluciones.forEach((e) => {
    let startY = doc.lastAutoTable ? doc.lastAutoTable.finalY + 10 : 60;
    startY = checkNewPage(doc, startY);

    doc.autoTable({
      startY,
      head: [[formatText("Fecha/Hora"), formatText("Usuario")]],
      body: [[e.fechahora, formatText(e.usuarioCreacion)]],
      theme: "grid",
      headStyles: { fillColor: [41, 128, 186], textColor: [255, 255, 255] },
      bodyStyles: { textColor: [0, 0, 0] },
      pageBreak: "avoid",
    });

    doc.autoTable({
      startY: doc.lastAutoTable.finalY,
      body: [[formatText(e.texto)]],
      theme: "plain",
      styles: { minCellHeight: 18, fontSize: 12, textColor: [0, 0, 0] },
      pageBreak: "avoid",
    });
  });

  applyHeaderFooter(doc, "Evoluciones", paciente);
  doc.save(`${formatText("Evoluciones")}_${formatText(paciente)}.pdf`);
}

/* === Medicaciones === */
export function exportarMedicacionesPDF(medicaciones, paciente) {
  const doc = new jsPDF("p", "mm", "a4");

  medicaciones.forEach((m) => {
    let startY = doc.lastAutoTable ? doc.lastAutoTable.finalY + 10 : 60;
    startY = checkNewPage(doc, startY);

    doc.autoTable({
      startY,
      head: [[formatText("Fecha/Hora"), formatText("Usuario")]],
      body: [[m.fechahora, formatText(m.usuarioCreacion)]],
      theme: "grid",
      headStyles: { fillColor: [41, 128, 186], textColor: [255, 255, 255] },
      bodyStyles: { textColor: [0, 0, 0] },
      pageBreak: "avoid",
    });

    doc.autoTable({
      startY: doc.lastAutoTable.finalY,
      body: [
        [`Medicacion: ${formatText(m.medicacion)}`],
        [`Dosis: ${m.dosis}`],
        [`Médico: ${formatText(m.medico)}`],
        [`Registro: ${m.registro}`],
      ],
      theme: "plain",
      styles: { textColor: [0, 0, 0] },
      pageBreak: "avoid",
    });
  });

  applyHeaderFooter(doc, "Medicaciones", paciente);
  doc.save(`${formatText("Medicaciones")}_${formatText(paciente)}.pdf`);
}

/* === Insumos Usados === */
export function exportarInsumosPDF(insumos, paciente) {
  const doc = new jsPDF("p", "mm", "a4");

  insumos.forEach((i) => {
    let startY = doc.lastAutoTable ? doc.lastAutoTable.finalY + 10 : 60;
    startY = checkNewPage(doc, startY);

    doc.autoTable({
      startY,
      head: [[formatText("Fecha/Hora"), formatText("Usuario")]],
      body: [[i.fechahora, formatText(i.usuarioCreacion)]],
      theme: "grid",
      headStyles: { fillColor: [41, 128, 186], textColor: [255, 255, 255] },
      bodyStyles: { textColor: [0, 0, 0] },
      pageBreak: "avoid",
    });

    doc.autoTable({
      startY: doc.lastAutoTable.finalY,
      body: [
        [`Insumo: ${formatText(i.insumo)}`],
        [`Cantidad: ${i.cantidad}`],
        [`Tipo: ${formatText(i.tipoinsumo)}`],
        [`Encargado: ${formatText(i.encargado)}`],
        [`Observación: ${formatText(i.obs)}`],
      ],
      theme: "plain",
      styles: { textColor: [0, 0, 0] },
      pageBreak: "avoid",
    });
  });

  applyHeaderFooter(doc, "Insumos Usados", paciente);
  doc.save(`${formatText("Insumos")}_${formatText(paciente)}.pdf`);
}

/* === Signos Vitales === */
export function exportarSignosPDF(signos, paciente) {
  const doc = new jsPDF("p", "mm", "a4");

  signos.forEach((s) => {
    let startY = doc.lastAutoTable ? doc.lastAutoTable.finalY + 10 : 60;
    startY = checkNewPage(doc, startY);

    doc.autoTable({
      startY,
      head: [[formatText("Fecha/Hora"), formatText("Usuario")]],
      body: [[s.fechahora, formatText(s.usuariocreacion)]],
      theme: "grid",
      headStyles: { fillColor: [41, 128, 186], textColor: [255, 255, 255] },
      bodyStyles: { textColor: [0, 0, 0] },
      pageBreak: "avoid",
    });

    doc.autoTable({
      startY: doc.lastAutoTable.finalY,
      body: [
        [`Temp: ${s.temperatura}`],
        [`SatO2: ${s.sato2}`],
        [`FR: ${s.fr}`],
        [`PA: ${s.pa}`],
        [`FC: ${s.fc}`],
        [`HGT: ${s.hgt}`],
      ],
      theme: "plain",
      styles: { textColor: [0, 0, 0] },
      pageBreak: "avoid",
    });
  });

  applyHeaderFooter(doc, "Signos Vitales", paciente);
  doc.save(`${formatText("SignosVitales")}_${formatText(paciente)}.pdf`);
}
